module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_move-2ae817734f1b14b217998e93078293ea.png";